export const ADD_USER_MESSAGE = 'ADD_USER_MESSAGE';
export const START_ASSISTANT_MESSAGE = 'START_ASSISTANT_MESSAGE';
export const UPDATE_STREAMING_ASSISTANT = 'UPDATE_STREAMING_ASSISTANT';
export const RECONCILE_ASSISTANT = 'RECONCILE_ASSISTANT';
export const SET_CONVERSATION_ID = 'SET_CONVERSATION_ID';
export const SET_SENDING = 'SET_SENDING';
export const SET_ERROR = 'SET_ERROR';
export const RESET = 'RESET';
export const FREEZE_ASSISTANT_STREAM = 'FREEZE_ASSISTANT_STREAM';
export const RESTORE_MESSAGES = 'RESTORE_MESSAGES';
export const SET_AI_ACCESS = 'SET_AI_ACCESS';
